module.exports = new __parcel__URL__("56700_h.66f87130.jpg").toString();